module.exports = __webpack_public_path__ + "static/media/port_saaid_thumb.f26a65e3.webp";